import { MutationTree } from "vuex";
import { DocumentState, CountryPayload, DocumentType } from "../types";

const mutations: MutationTree<DocumentState> = {
  setCountry(state, payload: CountryPayload) {
    state.country = payload.country;
    state.countryCode = payload.countryCode;
    state.supportedDocuments = payload.supportedDocuments;
  },
  setDocumentType(state, payload: DocumentType) {
    state.documentType = payload;
  },
};

export default mutations;
